import type { ReactNode } from 'react';
import { RoleBadge } from './index';

export interface ClubRowProps {
  name: string;
  description?: string;
  memberCount?: number;
  upcomingEventCount?: number;
  role?: 'leader' | 'moderator' | 'member' | 'none';
  onClick?: () => void;
  children?: ReactNode;
  className?: string;
}

export default function ClubRow({
  name,
  description,
  memberCount,
  upcomingEventCount,
  role = 'none',
  onClick,
  children,
  className = ''
}: ClubRowProps) {
  const formatStats = () => {
    const parts = [];
    if (typeof memberCount === 'number') {
      parts.push(`${memberCount} ${memberCount === 1 ? 'member' : 'members'}`);
    }
    if (typeof upcomingEventCount === 'number') {
      parts.push(`${upcomingEventCount} upcoming`);
    }
    return parts.join(' · ');
  };

  const baseClasses = `
    flex items-center gap-3 px-4 py-3
    hover:bg-surface-alt/60 transition-colors
    ${onClick ? 'cursor-pointer' : ''}
    ${className}
  `.trim();

  return (
    <li className={baseClasses} onClick={onClick}>
      <div className="flex-1 min-w-0">
        <h3 className="text-sm font-semibold text-text-primary mb-1 truncate">
          {name}
        </h3>
        {description && (
          <p className="text-xs text-text-muted mb-1 line-clamp-2">
            {description}
          </p>
        )}
        {formatStats() && (
          <p className="text-xs text-text-muted">
            {formatStats()}
          </p>
        )}
      </div>
      
      <div className="flex items-center gap-2 shrink-0">
        {role !== 'none' && (
          <RoleBadge role={role} size="xs" />
        )}
        {children}
      </div>
    </li>
  );
}